var path = '/modules/templates/views/pages/list.tpl.html';
var html = "<listview store=\"vm.templatesStore\"></listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/templates/views/pages/list.tpl.html
// module id = 2159
// module chunks = 1